import { Box, Button } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import { Add } from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import { handleFreeze } from "../../utils/common";
import { settingsClose } from "../../redux/reducers/companySkipSave";
import { showWarningSnackbar } from "../snackBar/snakbar";
import useControlledNavigation from "../../hooks/useControlledNavigation";

const LinkList = ({ list, link, add, name, handleClick, onClick }) => {
  const Freeze = useSelector(
    (state) => state.userPrefrenceandReducer?.financialYear?.freezestatus
  );
  const { saveSkipStatus } = useSelector(
    (state) => state.companySipSaveReducer
  );
  let dispatch = useDispatch();
  const navigate = useControlledNavigation();
  return (
    <Box sx={{ display: "flex", flex: { xs: 1, sm: 0 } }}>
      <Link
        onClick={(e) => {
          // Call custom onClick if provided
          if (onClick) {
            onClick?.();
          }
          
          if (Freeze == 1) {
            e.preventDefault();
            handleFreeze();
            return;
          }
          if (saveSkipStatus == false) {
            if (window.location.href.includes("companysetup")) {
              showWarningSnackbar("Please Complete the Company Setup Details");
            }
            e.preventDefault();
            dispatch(settingsClose());
            return navigate("/companysetup");
          }
          switch (name) {
            case "purchase": {
              localStorage.removeItem("PurchaseIDTaxable");
              localStorage.removeItem("PurchaseTaxViewMode");
              localStorage.removeItem("PurchaseIDNonTaxable");
              localStorage.removeItem("PurchaseNonTaxViewMode");
              return;
            }
            case "debit": {
              localStorage.removeItem("DebitNoteID");
              localStorage.removeItem("DebitNoteViewMode");
              return;
            }
            case "journal": {
              localStorage.removeItem("JournalTransactionID");
              localStorage.removeItem("JournalViewMode");
              return;
            }
            case "credit": {
              localStorage.removeItem("CreditNoteID");
              localStorage.removeItem("CreditNoteViewMode");
              return;
            }
            case "item": {
              handleClick(e);
              return;
            }
            default:
              return;
          }
        }}
        to={link}
      >
        <Button
          sx={{
            whiteSpace: "nowrap",
            border: "1px solid white",
            boxShadow: "0px 6px 8px rgba(0, 0, 0, 0.5)",
            m: { sm: "0 6px", md: "0 10px" },
            fontWeight: "bold",
            backgroundColor: "white",
            "&:hover": {
              backgroundColor: "white", // Override hover background color
            },
            height: "35px",
          }}
          variant="outlined"
          startIcon={<Add />}
        >
          {add}
        </Button>
      </Link>
    </Box>
  );
};

export default LinkList;
